// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".3faec3837960c91d9a64f2b6925b6957ef6adcd0.chunk.js";
};